import { useState, useEffect } from 'react';
import UserAvatar from './UserAvatar';
import { CheckIcon, SearchIcon, UserPlusIcon } from './Icons';

export default function AddMembersModal({ project, users, onAdd, onClose, showToast }) {
  const nonMembers = users.filter((u) => !project.members?.includes(u.uid));
  const [selected, setSelected] = useState([]);
  const [search, setSearch] = useState('');
  const [saving, setSaving] = useState(false);

  const toggle = (uid) =>
    setSelected((prev) => prev.includes(uid) ? prev.filter((id) => id !== uid) : [...prev, uid]);

  const filtered = nonMembers.filter((u) =>
    !search || u.displayName?.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handler);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const handleSave = async () => {
    if (selected.length === 0) return;
    setSaving(true);
    try {
      await onAdd(project.id, selected);
      onClose();
    } catch (err) {
      showToast(err.message || 'Failed to add members', 'error');
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="add-members-panel" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="add-members-header">
          <UserPlusIcon size={15} />
          <span>Add to <strong>{project.name}</strong></span>
        </div>

        {/* Search */}
        <div className="add-members-search">
          <SearchIcon size={13} />
          <input
            autoFocus
            type="text"
            placeholder="Search users…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="add-members-search-input"
          />
        </div>

        {/* User list */}
        <div className="add-members-list">
          {nonMembers.length === 0 ? (
            <p className="add-members-empty">All users are already members.</p>
          ) : filtered.length === 0 ? (
            <p className="add-members-empty">No users match "{search}"</p>
          ) : (
            filtered.map((u) => {
              const isSelected = selected.includes(u.uid);
              return (
                <button
                  key={u.uid}
                  className={`add-members-option${isSelected ? ' add-members-option--selected' : ''}`}
                  onClick={() => toggle(u.uid)}
                >
                  <div className="add-members-option-left">
                    <UserAvatar user={u} size={30} showStatus={false} />
                    <span className="add-members-option-name">{u.displayName}</span>
                  </div>
                  {isSelected && <CheckIcon size={14} className="add-members-check" />}
                </button>
              );
            })
          )}
        </div>

        {/* Footer */}
        <div className="add-members-footer">
          <button className="btn btn-ghost btn-sm" onClick={onClose}>Cancel</button>
          <button
            className="btn btn-primary btn-sm"
            onClick={handleSave}
            disabled={selected.length === 0 || saving}
          >
            {saving ? 'Adding…' : selected.length > 0 ? `Add ${selected.length} member${selected.length !== 1 ? 's' : ''}` : 'Add members'}
          </button>
        </div>
      </div>
    </div>
  );
}
